import React from 'react';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import BaseProps from "../../types/BaseProps";
import classNames from 'classnames';

import './DataTable.scss';

export type TableColumn = {
  label: string;
  key: string;
}

export type TableRow = {
  [key: string]: any
}

export type TableModel = {
  columns: TableColumn[];
  data: TableRow[];
}

type DataTableProps = BaseProps & {
  model: TableModel;
}

type DataTableState = {
  model: TableModel;
}

class DataTable extends React.Component<DataTableProps, DataTableState> {

  constructor(props: DataTableProps) {
    super(props);
    this.state = {
      model: this.props.model
    };
  }

  componentWillReceiveProps(nextProps: DataTableProps) {
    if (nextProps.model !== this.state.model) {
      this.setState({model: nextProps.model});
    }
  }

  onFilter = (event: any): void => {
    const target = event.target;
    const filter: string = target.value;
    const {columns, data} = this.props.model;
    const columnKeys: string[] = columns.map((column) => column.key);
    this.setState({
      model: {
        columns,
        data: data.filter((row) => {
          return columnKeys.some((key) => {
            return row[key].indexOf(filter) !== -1;
          })
        })
      }
    });
  }

  render() {
    const {columns, data} = this.state.model;
    const columnKeys: string[] = columns.map((column) => column.key);
    const classes = classNames('DataTable', this.props.className);

    return (
      <Table striped bordered hover size="sm" className={classes}>
        <caption>
          <Form.Control type="text" placeholder="Filter..." className="filter-field"
                        onChange={this.onFilter}
                        autoComplete="off"/>
        </caption>
        <thead>
        <tr>
          {
            columns.map((column, index) => <th key={index}>{column.label}</th>)
          }
        </tr>
        </thead>
        <tbody>
        {
          data.map((row, index) => <TableRow row={row} keys={columnKeys} index={index}
                                             key={index}/>)
        }
        </tbody>
      </Table>
    );
  }
}

function TableRow(props: { row: TableRow, keys: string[], index: number }) {
  return <tr key={props.index}>
    {
      props.keys.map((key, i: number) => (
        <td key={i}>{props.row[key]}</td>
      ))
    }
  </tr>
}

export default DataTable;
